import React from "react";
var __jsx = React.createElement;
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import RichTextAdapter from "../../atoms/RichText/RichTextAdapter";
import Para from "../../atoms/Para";
var RichTextBlob = function RichTextBlob(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  var dataRichTextBlob = useContentfulLiveUpdates(entry);
  var topPadding = dataRichTextBlob.topPadding,
    bottomPadding = dataRichTextBlob.bottomPadding;
  var className = "nva-rtb rich-text-blob container";
  // top padding from contentful
  className += topPadding === null || topPadding === 'Default' || topPadding === undefined ? '' : " padding-top-override-".concat(topPadding === null || topPadding === void 0 ? void 0 : topPadding.toLowerCase());
  // bottom padding from contentful
  className += bottomPadding === null || bottomPadding === 'Default' || bottomPadding === undefined ? '' : " padding-bottom-override-".concat(bottomPadding === null || bottomPadding === void 0 ? void 0 : bottomPadding.toLowerCase());
  var anchorLink = (dataRichTextBlob === null || dataRichTextBlob === void 0 ? void 0 : dataRichTextBlob.anchorLink) || '';
  return __jsx("div", {
    className: className,
    style: {
      padding: data.pagePath == '/terms-conditions' || data.pagePath == '/thank-you' || data.pagePath == '/privacy-policy' ? '80px 25px' : '80px 0px'
    },
    id: anchorLink
  }, __jsx("div", {
    className: "block block0 col-xs-12"
  }, (entry === null || entry === void 0 ? void 0 : entry.categoryTitle) && __jsx(Para, {
    className: "nva-rtb__category-title u-overline"
  }, entry.categoryTitle), __jsx(RichTextAdapter, {
    entry: dataRichTextBlob
  })));
};
export default RichTextBlob;